import React, {useCallback} from 'react';
import {CellLink} from './CellLink';
import {NavigateFunction, useNavigate} from 'react-router-dom';
import {ILinkStyles, Theme, useTheme} from 'components/FluentUICompat';

interface Props {
	href: string;
	children: React.ReactNode;
	target?: '_blank' | '_self';
}

const getStyles = (theme: Theme) =>
	({
		root: {
			'&, *': {cursor: 'pointer'},
			color: theme.palette.neutralPrimary,
		},
	} as ILinkStyles);

export function CellWithEntityLink({
	href,
	children,
	target,
}: Props): React.ReactElement {
	const navigate: NavigateFunction = useNavigate();
	const theme = useTheme();
	const styles = React.useMemo(() => getStyles(theme), [theme]);

	const openDetailsPage = useCallback(async (): Promise<void> => {
		if (target === '_blank') {
			window.open(href, '_blank');
		} else {
			await navigate(href);
		}
	}, [href, navigate, target]);

	return (
		<CellLink onClick={openDetailsPage} styles={styles}>
			{children}
		</CellLink>
	);
}
